/*
 * @Author: songxiaoqiang
 * @Date: 2020-09-21 17:49:46
 * @Last Modified by: songxiaoqiang
 * @Last Modified time: Do not edit
 * @Description:
 */
import React from "react";
import PropTypes from "prop-types";
import Request from "../../utils/request";
import utils from "../../utils/utils";
import InfiniteScroll from 'react-infinite-scroll-component';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import "./style.less";

const env = process.env.NODE_ENV
class PipelineGoodsRecommend extends React.Component {
  constructor(props) {
    super(props);
    const { config, hasNavigation, componentIndex, componentLength } = props
    const { categories, baseConfig } = config
    const { goodsNum, productStyle } = baseConfig;

    const initList = []; // 根据商品数量，初始化列表占位数据
    const placeItemNum = goodsNum < 10 ? goodsNum : 10;
    for (let i = 0; i < placeItemNum; i += 1) {
      initList.push({
        image: 'https://static.shihuocdn.cn/admin/files/20210406/8d9ebe0ba03eeade62495c93303d6de2.png',
      });
    }
    this.state = {
      initList,
      itemList: [],
      userId: null,
      deviceCode: null,
      deviceType: utils.isAndroid() ? "ANDROID" : "IOS",
      abtest: "",
      categories,
      baseConfig,
      hashmore: true,
      hasRequest: false, // 判断是否发出了请求
      goodsNum: goodsNum,
      productStyle: productStyle,
      componentIndex,
      hasNavigation,
      componentLength,
      pageParam: {                    
        pageNum: 1,
        pageSize: 10
      }
    };
  }

  componentDidMount() {
   
    const { 
      pageParam, 
      categories, 
      hasNavigation,
      goodsNum, 
      componentIndex,
      componentLength,
      productStyle,
      baseConfig
     } = this.state

    if(categories.length == 0){
      return false
    } 

    Promise.all([utils.getCookie( "u"), utils.getDeviceInfo()]).then((values)=>{
      console.log('promise-----', values)

      const userId = values[0] ? values[0].split("|")[0] : null
      const deviceCode = values[1].deviceId || baseConfig.deviceCode
      const abtest_tag = values[1].abtest_tag || ""
      console.log(`---recommend`, baseConfig)
      this.setState({
        userId,
        deviceCode,
        abtest_tag
      }, ()=>{
        if(categories.length > 0){
          if(
            ((componentIndex == componentLength -1) 
            || goodsNum == pageParam.pageSize)
            && productStyle !== '一行一排'
          ){
            (async ()=>{
              this.getRecommendListData({
                pageParam
              })
            })()
          }else{
            this.requestTotalGoods()
          }
        }
      })
    })

  }
  
  requestTotalGoods() {
    const { goodsNum, pageParam } = this.state
    const looptimes = Math.round( goodsNum / pageParam.pageSize)
    const leftNums = goodsNum % pageParam.pageSize

    utils.asyncForEach(new Array(looptimes), async(item, index)=>{
      await this.getRecommendListData({
        pageParam: {
          pageNum: index+1,
          pageSize: this.state.pageParam.pageSize
        }
      })
    })
  }
  // options: {type: 商品维度， rootId: 一级类目ID，childId: 二级类目ID}
  async getRecommendListData(options) {
    const { 
      userId, 
      deviceCode, 
      deviceType, 
      categories, 
      itemList, 
      goodsNum,
      abtest_tag
    } = this.state
    const { pageParam } = options
    const filteCcategories = Object.assign([], categories.map((item)=>{
      if(item.childId === -1){
        delete item.childId
      }
      return item
    }))
    const params = {
          categories: filteCcategories,
          scene: "NEW_TOPIC_GOODSLIST",
          page_num: pageParam.pageNum,
          page_size: pageParam.pageSize,
        } 
    const reqUrl = 'https://sh-gateway.shihuo.cn/v4/services/sh-specialapi/recommend/custom/info?access_token=znSnA7pxO35wtPBaur';

    try{
      const res = await Request({
        url: reqUrl,
        method: "post",
        withCredentials: true,
        headers: {
          "Abtest-Control": abtest_tag
        },
        data: params,
      })

      if (res.data.status === 0) {    
        const items = res.data.data.List || [];
        let newItemList = itemList.concat(items);
        if (newItemList.length >= goodsNum) {
          // 超出数量限制，加载结束，对数据截断
          newItemList = newItemList.slice(0, goodsNum);
          this.setState({
            hashmore: false
          });
        }
        console.log(items, goodsNum, newItemList.length, '推荐列表')

        this.setState({
          itemList: newItemList,
          hasRequest: true,
        });
      } 
    }catch(e){
    }
  }

  // async getProductListData(options) {
  //   const {itemList, type, pageParam } = options;
  //   const { pageNum } = pageParam
  //   const idList = itemList.map((item) => {
  //     if(item.itemId.indexOf('p') >= 0){
  //       return {
  //         style_id: parseInt(item.itemId.replace("p", ""))
  //       }
  //     }else{
  //       return {
  //         goods_id: parseInt(item.itemId.replace("g", ""))
  //       }
  //     }
  //   });

  //   let reqUrl = "https://sh-gateway.shihuo.cn/v4/services/sh-specialapi/mixed/info?access_token=znSnA7pxO35wtPBaur";

  //   try{
  //     const res = await axios({
  //       url: reqUrl,
  //       method: "post",
  //       withCredentials: true,
  //       data: {
  //         ids: idList
  //       },
  //     })
  //     if (res.data.status === 0) {
  //       const list = res.data.data.List;
  //       // 插入定制化内容
  //       list.forEach((product) => {
  //         const customItem = itemList.find((item) => item.id == product.id);
  //         if (customItem) {
  //           product.custom_title = customItem.name;
  //           product.custom_recommend = customItem.recommend;
  //         }
  //       });
  //       if(pageNum == 1){
  //         this.setState({
  //           list,
  //         });
  //       }else{
  //         const newList = this.state.list.concat(list)
  //         this.setState({
  //           list: newList
  //         })
  //       }
  //     }
  //   }catch(e){
  //     alert(e)
  //   }
  // }

  fetchMoreData() {
    const { pageNum } = this.state.pageParam
    this.setState({
      pageParam: Object.assign({}, this.state.pageParam, {
        pageNum: pageNum + 1
      })
    }, ()=>{
      (async ()=>{
        await this.getRecommendListData({
          pageParam: this.state.pageParam
        })
      })()
    })
  }

  handleItemClick(item, index) {
    if (this.props.templateName === 'toufang') {
      utils.handleToufangClick({
        link: item.url,
        props: this.props,
        index
      })
      return
    }
    const baseConfig = this.props.config.baseConfig;
    const { itemList } = this.state

    const options = {
      title: baseConfig.title,
      type: baseConfig.productStyle,
      sort: index,
    };
    const ptiOptions = {};
    if (itemList[index].goodsId) {
      options.goods_id = item.id;
      ptiOptions.goods_id = item.id;
    } else {
      options.style_id = item.id;
      ptiOptions.style_id = item.id;
    }
    utils.jumpToUrl(this.props.routeParams,item.url,item.url,options,item.id,this.props, false, ptiOptions);
  }

  productBannerGo = (url) => {
    if (this.props.templateName === 'toufang') {
      utils.handleToufangClick({
        link: url,
        props: this.props,
      })
      return
    }
    // 商品banner跳转
    const options = {};
    const convertUrl = utils.convertHref(url);
    utils.jumpToUrl(this.props.routeParams,convertUrl,url,options,-1,this.props,false);

  };

  renderLoading (){
    const { hashmore,itemList, pageParam } = this.state
    if(!this.state.hashmore || itemList.length <= pageParam.pageSize){
      return null
    }
    return (
      <div className="loading-view">
          <img className="animation" src="https://static.shihuocdn.cn/admin/files/20210224/4620e31e536747b8588f2c936b3e583d.gif" />
          <span className="text">加载中...</span>
      </div>
    )
  }

  render() {
    const { baseConfig, categories } = this.props.config;
    const { goodsNum, hashmore } = this.state;
    const bodyWidth = typeof window !== "undefined" ? window.document.body.clientWidth : 375;

    // 判断不同布局方式下的间距取值
    if (baseConfig.productStyle === "一行一个") {
      Object.assign(baseConfig, baseConfig.layout_1);
    } else if (baseConfig.productStyle === "一行两个") {
      Object.assign(baseConfig, baseConfig.layout_2);
    } else if (baseConfig.productStyle === "一行三个") {
      Object.assign(baseConfig, baseConfig.layout_3);
    } else if (baseConfig.productStyle === "一行一排") {
      Object.assign(baseConfig, baseConfig.layout_row);
    }

    // 请求未发出之前，使用初始占位数据，请求成功之后，使用返回数据
    let productList;
    if (this.state.hasRequest) {
      productList = this.state.itemList;
    } else {
      productList = this.state.initList;
    }
    // 转为数字处理，后续参与计算
    baseConfig.itemMargin = isNaN(Number(baseConfig.itemMargin))
      ? 0
      : Number(baseConfig.itemMargin);

    return (
      <div
        className="pipeline-goodsRecommend"
        id={this.props['customAttributes']['data-component-id']}
        name={baseConfig.title}
        {...this.props['customAttributes']}
        style={{
          paddingTop: baseConfig.moduleMarginTop >= 0 ? `${baseConfig.moduleMarginTop}px` : 0,
          marginTop: baseConfig.moduleMarginTop < 0 ? `${baseConfig.moduleMarginTop}px` : 0,
          marginLeft: `${baseConfig.moduleMarginHorizon}px`,
          marginRight: `${baseConfig.moduleMarginHorizon}px`,
          marginBottom: this.props.showCompMarginBottom ? '8px' : '0px'
        }}
      >
        {baseConfig.showTitle && (
          <div>
            <div className="title" style={{ color: baseConfig.titleColor }}>
              {baseConfig.title}
            </div>
            <div className="sub-title" style={{ color: baseConfig.titleColor }}>
              {baseConfig.subTitle}
            </div>
          </div>
        )}
        {baseConfig.imgUrl && (
          <img
            className="product-banner"
            onClick={this.productBannerGo.bind(this, baseConfig.imgLink)}
            src={utils.formatImgUrl(baseConfig.imgUrl, this.props.webpSupport)}
            alt=""
          />
        )}
        {baseConfig.productStyle !== "一行一排" ? (
          <div>
             <InfiniteScroll
              dataLength={productList.length}
              next={this.fetchMoreData.bind(this)}
              hasMore={hashmore}
              loader={this.renderLoading()}
              className="product-list"
              scrollableTarget="product-list"
            >
              {productList.map((item, index) => {
                let rowItemNumber = 3; // 每行排列数量
                if (baseConfig.productStyle === "一行一个") {
                  rowItemNumber = 1;
                } else if (baseConfig.productStyle === "一行两个") {
                  rowItemNumber = 2;
                } else if (baseConfig.productStyle === "一行三个") {
                  rowItemNumber = 3;
                }

                // 行数计算
                const currentRowIndex = Math.floor(index / rowItemNumber) + 1;
                const totalRowNum = Math.ceil(productList.length / rowItemNumber);
                const isFirstRow = Boolean(currentRowIndex === 1); // 该项是否在首行
                const isLasthRow = Boolean(totalRowNum === currentRowIndex); // 该项是否在未行
                const isFirstColumn = Boolean(index % rowItemNumber === 0);
                const isLastColumn = Boolean((index + 1) % rowItemNumber === 0); // 该项是否在未列

                // 计算每个项的宽度
                const totalMargin = (rowItemNumber - 1) * baseConfig.itemMargin;
                const itemWidth = `calc((100% - ${totalMargin}px) / ${rowItemNumber})`;
                const itemStyle = {
                  width: itemWidth,
                  marginTop: isFirstRow ? "0" : `${baseConfig.itemMargin / 2}px`,
                  marginBottom: isLasthRow
                    ? "0"
                    : `${baseConfig.itemMargin / 2}px`,
                  marginLeft: isFirstColumn
                    ? "0"
                    : `${baseConfig.itemMargin / 2}px`,
                  marginRight: isLastColumn
                    ? "0"
                    : `${baseConfig.itemMargin / 2}px`,
                };

                let productItem;
                if (baseConfig.productStyle === "一行一个") {
                  // 四个展示都存在是，隐藏销量
                  if (
                    baseConfig.originPrice &&
                    baseConfig.saleNum &&
                    baseConfig.priceIcon
                  ) {
                    baseConfig.saleNum = false;
                  }
                  productItem = (
                    <div
                      ref={ele => {
                        if (ele) {
                          this.props.exp && this.props.exp(ele);
                        }
                      }}
                      data-dot={JSON.stringify(utils.getExposureData(this.props, {
                        title: baseConfig.title,
                        type: baseConfig.productStyle,
                        sort: index,
                        goods_id: item.id,
                        style_id: item.id,
                      }))}
                      className="product-item row-one-item"
                      key={index}
                      style={itemStyle}
                      onClick={this.handleItemClick.bind(this, item, index)}
                    >
                      <div className="product-img-panel">
                        <LazyLoadImage
                          width={110}
                          height={110}
                          src={utils.formatImgUrl(item.image, this.props.webpSupport)}
                        />
                      </div>
                      <div className="product-info">
                        <div className="info">
                          <div
                            className="name"
                            style={{ WebkitBoxOrient: "vertical" }}
                          >
                            {item.custom_title || item.title}
                          </div>
                          {baseConfig.slogen && (
                            <div className="tag">
                              {(item.custom_recommend || item.recommend) && (
                                <div className="tag-text">
                                  {item.custom_recommend || item.recommend}
                                </div>
                              )}
                            </div>
                          )}
                        </div>
                        <div className="sale">
                          <div className="price-container">
                            {baseConfig.priceIcon && (
                              <img
                                className="price-icon"
                                src={utils.formatImgUrl(baseConfig.priceIcon, this.props.webpSupport)}
                              />
                            )}
                            <div className="price">
                              {item.id && (
                                <span className="rmb-icon">&yen;</span>
                              )}
                              {item.price}
                            </div>
                            {baseConfig.originPrice &&
                              item.original_price > item.price &&
                              item.original_price > 0 && (
                                <span className="origin-price">
                                  &yen;{item.original_price}
                                </span>
                              )}
                          </div>
                          {baseConfig.saleNum && item.id && item.sell_point > 0 && (
                            <div className="num">{item.sell_point_str.indexOf('W') < 0 ? item.sell_point_str : item.sell_point_str.replace('W', 'w')}人付款</div>
                          )}
                        </div>
                      </div>
                      {baseConfig.markIcon && (
                        <img className="mark-icon" src={utils.formatImgUrl(baseConfig.markIcon, this.props.webpSupport)} />
                      )}
                    </div>
                  );
                } else if (baseConfig.productStyle === "一行两个") {
                  // 四个展示都存在是，隐藏销量
                  if (
                    baseConfig.originPrice &&
                    baseConfig.saleNum &&
                    baseConfig.priceIcon
                  ) {
                    baseConfig.saleNum = false;
                  }
                  // 计算一行二商品图片宽度
                  const productImgWidth = (bodyWidth - Number(baseConfig.moduleMarginHorizon) * 2 - Number(baseConfig.itemMargin)) / 2 - 6;
                  productItem = (
                    <div
                      ref={ele => {
                        if (ele) {
                          this.props.exp && this.props.exp(ele);
                        }
                      }}
                      data-dot={JSON.stringify(utils.getExposureData(this.props, {
                        title: baseConfig.title,
                        type: baseConfig.productStyle,
                        sort: index,
                        goods_id: item.id,
                        style_id: item.id,
                      }))}
                      className="product-item row-two-item"
                      key={index}
                      style={itemStyle}
                      onClick={this.handleItemClick.bind(this, item, index)}
                    >
                      <div className="product-img-panel" style={{ margin: 3 }}>
                        <LazyLoadImage
                          width={productImgWidth}
                          height={productImgWidth}
                          src={utils.formatImgUrl(item.image, this.props.webpSupport)}
                        />
                      </div>
                      <div className="product-info">
                        <div className="info">
                          <div
                            className="name"
                            style={{ WebkitBoxOrient: "vertical" }}
                          >
                            {item.custom_title || item.title}
                          </div>
                          {baseConfig.slogen && (
                            <div className="tag">
                              {(item.custom_recommend || item.recommend) && (
                                <div className="tag-text">
                                  {item.custom_recommend || item.recommend}
                                </div>
                              )}
                            </div>
                          )}
                        </div>
                        <div className="sale">
                          <div className="price-container">
                            {baseConfig.priceIcon && (
                              <img
                                className="price-icon"
                                src={utils.formatImgUrl(baseConfig.priceIcon, this.props.webpSupport)}
                              />
                            )}
                            <div className="price">
                              {item.id && (
                                <span className="rmb-icon">&yen;</span>
                              )}
                              {item.price}
                            </div>
                            {baseConfig.originPrice &&
                              item.original_price > item.price &&
                              item.original_price > 0 && (
                                <span className="origin-price">
                                  &yen;{item.original_price}
                                </span>
                              )}
                          </div>
                          {baseConfig.saleNum && item.id && item.sell_point > 0 && (
                            <div className="num">{item.sell_point_str.indexOf('W') < 0 ? item.sell_point_str : item.sell_point_str.replace('W', 'w')}人付款</div>
                          )}
                        </div>
                      </div>
                      {baseConfig.markIcon && (
                        <img className="mark-icon" src={utils.formatImgUrl(baseConfig.markIcon, this.props.webpSupport)} />
                      )}
                    </div>
                  );
                } else if (baseConfig.productStyle === "一行三个") {
                  // 四个展示都存在是，隐藏销量
                  if (baseConfig.originPrice && baseConfig.saleNum) {
                    baseConfig.saleNum = false;
                  }
                  // 计算一行三商品图片宽度
                  const productImgWidth = (bodyWidth - Number(baseConfig.moduleMarginHorizon) * 2 - Number(baseConfig.itemMargin) * 2) / 3;
                  productItem = (
                    <div
                      ref={ele => {
                        if (ele) {
                          this.props.exp && this.props.exp(ele);
                        }
                      }}
                      data-dot={JSON.stringify(utils.getExposureData(this.props, {
                        title: baseConfig.title,
                        type: baseConfig.productStyle,
                        sort: index,
                        goods_id: item.id,
                        style_id: item.id,
                      }))}
                      className="product-item row-three-item"
                      key={index}
                      style={itemStyle}
                      onClick={this.handleItemClick.bind(this, item, index)}
                    >
                      <div className="product-img-panel">
                        <LazyLoadImage
                          width={productImgWidth}
                          height={productImgWidth}
                          src={utils.formatImgUrl(item.image, this.props.webpSupport)}
                        />
                      </div>
                      <div className="product-info">
                        <div className="info">
                          <div
                            className="name"
                            style={{ WebkitBoxOrient: "vertical" }}
                          >
                            {item.custom_title || item.title}
                          </div>
                          {baseConfig.slogen && (
                            <div className="tag">
                              {(item.custom_recommend || item.recommend) && (
                                <div className="tag-text">
                                  {item.custom_recommend || item.recommend}
                                </div>
                              )}
                            </div>
                          )}
                        </div>
                        <div className="sale">
                          <div className="price">
                            {item.id && (
                              <span className="rmb-icon">&yen;</span>
                            )}
                            {item.price}
                          </div>
                          {baseConfig.originPrice &&
                            item.original_price > item.price &&
                            item.original_price > 0 && (
                              <span className="origin-price">
                                &yen;{item.original_price}
                              </span>
                            )}
                          {baseConfig.saleNum && !baseConfig.originPrice && item.sell_point > 0 && (
                            <div className="num">{item.sell_point_str.indexOf('W') < 0 ? item.sell_point_str : item.sell_point_str.replace('W', 'w')}人付款</div>
                          )}
                        </div>
                      </div>
                      {baseConfig.markIcon && (
                        <img className="mark-icon" src={utils.formatImgUrl(baseConfig.markIcon, this.props.webpSupport)} />
                      )}
                    </div>
                  );
                }
                return productItem;
              })}
            </InfiniteScroll>
          </div>
        ) : (
          <div className="product-swiper-container">
            {/* <div className="product-title">
              <div className="name">NIKE AIR FORCE 1</div>
              <div className="num">月销12.4w</div>
            </div> */}
            <div className="swiper-list">
              {productList.map((item, index) => {
                // 折扣计算
                let discountRate = item.price / item.original_price;
                if (
                  discountRate > 1 ||
                  isNaN(discountRate) ||
                  item.original_price === 0
                ) {
                  discountRate = 1;
                }
                discountRate = discountRate * 10;
                discountRate = discountRate.toFixed(1);

                const itemStyle = {
                  paddingLeft:
                    index === 0
                      ? `${baseConfig.itemMargin}px`
                      : `${baseConfig.itemMargin / 2}px`,
                  paddingRight:
                    index === productList.length - 1
                      ? `${baseConfig.itemMargin}px`
                      : `${baseConfig.itemMargin / 2}px`,
                };
                return (
                  <div
                    ref={ele => {
                      if (ele) {
                        this.props.exp && this.props.exp(ele);
                      }
                    }}
                    data-dot={JSON.stringify(utils.getExposureData(this.props, {
                      title: baseConfig.title,
                      type: baseConfig.productStyle,
                      sort: index,
                      goods_id: item.id,
                      style_id: item.id,
                    }))}
                    className="product-item"
                    onClick={this.handleItemClick.bind(this, item, index)}
                    style={itemStyle}
                  >
                    <div className="product-img-panel">
                      <LazyLoadImage
                        width={90}
                        height={90}
                        src={utils.formatImgUrl(item.image, this.props.webpSupport)}
                      />
                    </div>
                    <div className="product-name">
                      {item.custom_title || item.title}
                    </div>
                    <div className="price-info">
                      {item.id && (
                        <div className="rmb-icon">￥</div>
                      )}
                      <div className="price-num">{item.price}</div>
                      {discountRate !== "10.0" && item.id && (
                        <div className="discount">{discountRate}折</div>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </div>
    );
  }
}

PipelineGoodsRecommend.propTypes = {
  config: PropTypes.object.isRequired,
};

export { PipelineGoodsRecommend };
export default PipelineGoodsRecommend;



// WEBPACK FOOTER //
// ./components/pipeline-goodsRecommend/index.js